import {SwitchTextTypeTool} from 'substance'
import ContentMenuItem from './ContentMenuItemComponent'

class DWSwitchTextTypeTool extends SwitchTextTypeTool {
    render($$) {
        var el = $$('ul').addClass('context-menu')

        const textTypes = this.props.textTypes.map((textType) => {

            let combo = ''
            if (textType.command) {
                combo = this.context.configurator.dwKeyboardManager.getShortcutForCommand(textType.command)
            }

            return $$(ContentMenuItem, {
                label: textType.name,
                combo: combo,
                active: textType.name === this.props.currentTextType.name
            }).on('click', this.handleClick).attr('data-type', textType.name)
        })

        el.append(textTypes)


        return el
    }

    handleClick(e) {
        e.preventDefault()
        this.executeCommand(e.currentTarget.dataset.type)
    }
}

export {DWSwitchTextTypeTool}
